import { loadScript } from '../../shared/actions/scripts.action'

export const startStripe = () => dispatch => {
  loadScript('Stripe', 'https://js.stripe.com/v2/')(dispatch).then(initialize)
}

function initialize() {
  window.Stripe.setPublishableKey(process.env.STRIPE_KEY)
}
